import { Stack, TypographyProps } from "@mui/material";
import TextFieldControl from "components/form/TextFieldControl";
import { ReactNode } from "react";
import PasswordStrength from "./PasswordStrength";
import { hasPasswordLettersAndDigits, PASSWORD_MIN_LENGTH } from "./utils";

type AuthPasswordFieldsProps = {
  confirmPasswordName?: string;
  confirmPasswordLabel?: ReactNode;
  confirmPasswordPlaceholder?: string;
  labelTypographyProps?: TypographyProps;
  password: string;
  passwordLabel?: ReactNode;
  passwordName?: string;
  passwordPlaceholder?: string;
  showStrength?: boolean;
};

const AuthPasswordFields = ({
  confirmPasswordLabel = "Повторите пароль",
  confirmPasswordName = "confirmPassword",
  confirmPasswordPlaceholder = "Повторите пароль",
  labelTypographyProps,
  password,
  passwordLabel = "Пароль",
  passwordName = "password",
  passwordPlaceholder = "Минимум 8 символов",
  showStrength = true,
}: AuthPasswordFieldsProps) => (
  <>
    <Stack spacing={showStrength ? 1 : 0}>
      <TextFieldControl
        label={passwordLabel}
        type='password'
        name={passwordName}
        variant='outlined'
        labelTypographyProps={labelTypographyProps}
        placeholder={passwordPlaceholder}
        rules={{
          required: true,
          minLength: {
            value: PASSWORD_MIN_LENGTH,
            message: "Минимум 8 символов",
          },
          validate: (value) => hasPasswordLettersAndDigits(value) || "Пароль должен содержать буквы и цифры",
        }}
      />

      {showStrength && <PasswordStrength password={password} />}
    </Stack>

    <TextFieldControl
      label={confirmPasswordLabel}
      type='password'
      name={confirmPasswordName}
      variant='outlined'
      labelTypographyProps={labelTypographyProps}
      placeholder={confirmPasswordPlaceholder}
      rules={{
        required: true,
        validate: (value, formValues) => value === formValues[passwordName] || "Пароли не совпадают",
      }}
    />
  </>
);

export default AuthPasswordFields;
